// extracted by mini-css-extract-plugin
module.exports = {"category":"QuestionCategory_category__3afsN","title":"QuestionCategory_title__3B5M8","button":"QuestionCategory_button__1ygI7","icon":"QuestionCategory_icon__2LNfw"};